import type { ReactNode } from "react"
import { useNavigate } from "react-router-dom"
import { MobileTopNav } from "@/components/mobile"
import { ScrollToTop } from "@/components/shared/ScrollToTop"
import { getAssetUrl } from "@/utils/assets"

interface MobileAuthLayoutProps {
  children?: ReactNode
  showBackButton?: boolean
  showLogo?: boolean
  enableSmartNavigation?: boolean
  onNavigateBack?: () => void
  centerContent?: boolean
}

export function MobileAuthLayout({
  children,
  showBackButton = true,
  showLogo = false,
  enableSmartNavigation = false,
  onNavigateBack,
  centerContent = false,
}: MobileAuthLayoutProps) {
  const navigate = useNavigate()
  const backgroundImage = getAssetUrl("auth-bg.jpeg")
  const logoLight = getAssetUrl("auth-logo.png")
  const symbolSrc = getAssetUrl("symbol.svg")

  const handleBack = () => {
    if (enableSmartNavigation) {
      return
    } else if (onNavigateBack) {
      onNavigateBack()
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="min-h-screen relative">
      <ScrollToTop />

      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          height: "50vh",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          height: "50vh",
          background:
            "linear-gradient(rgba(2, 2, 2, 0.36) 0%, rgba(2, 2, 2, 0.71) 0%, #020202 90%)",
        }}
      />

      <div className={`relative z-10 ${centerContent ? "min-h-screen flex flex-col" : ""}`}>
        {showBackButton && <MobileTopNav variant="back-more" onBack={handleBack} />}

        {/* Logo Branding - Centered */}
        {showLogo && (
          <div className="flex flex-col items-center justify-center pt-4.5 pb-[55px] gap-2.5">
            <img src={symbolSrc} alt={"app-symbol"} className="h-[87px] w-[110px]" />
            <img src={logoLight} alt={"app-logo"} className=" w-[200px] h-10" />
          </div>
        )}

        <div className={`px-5 pb-5 ${centerContent ? "flex-1 flex flex-col justify-center" : ""}`}>
          {children}
        </div>
      </div>
    </div>
  )
}
